import searchStore from '../store/Store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('resetSearchState', function resetSearchState() {
    searchStore.searchText = '';
    searchStore.suggestionPill = null;
    searchStore.staticFolderScopeId = null;
    searchStore.previouslySelectedFolderId = null;
});
